import * as React from "react";
import type { SVGProps } from "react";
const SvgIconGoogle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 76 75"
    {...props}
  >
    <path
      fill="#4285F4"
      d="M70.518 38.22c0-2.698-.223-4.667-.707-6.708H38.375v12.177h18.453c-.372 3.026-2.381 7.583-6.846 10.645l-.062.408 9.94 7.546.688.068c6.324-5.725 9.97-14.147 9.97-24.136"
    />
    <path
      fill="#34A853"
      d="M38.373 70.304c9.04 0 16.63-2.917 22.173-7.948L49.98 54.335c-2.827 1.932-6.622 3.28-11.607 3.28-8.854 0-16.369-5.723-19.047-13.635l-.393.033-10.335 7.839-.136.368c5.506 10.719 16.816 18.084 29.911 18.084"
    />
    <path
      fill="#FBBC05"
      d="M19.327 43.981a19.8 19.8 0 0 1-1.116-6.49c0-2.26.41-4.447 1.08-6.49l-.02-.434-10.464-7.965-.343.16c-2.269 4.448-3.57 9.443-3.57 14.73 0 5.286 1.301 10.28 3.57 14.729z"
    />
    <path
      fill="#EB4335"
      d="M38.373 17.366c6.287 0 10.528 2.662 12.947 4.886l9.45-9.042c-5.804-5.286-13.357-8.531-22.397-8.531-13.095 0-24.405 7.364-29.91 18.083l10.825 8.24c2.716-7.912 10.231-13.636 19.085-13.636"
    />
  </svg>
);
export default SvgIconGoogle;
